export default "__VITE_ASSET__BQQn7__a__"